// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const chalkBluff = defineModel({
  id: "chalk-bluff",
  batchId: "future",
  name: "Chalk bluff",
  tags: ["scenery","chalk","bluff","low-poly","age-of-mcp","future"],
  summary: "A soft chalk mound. Burns to lime, makes whitewash and gesso, and sweetens sour soil.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.44,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.3, 0.4, 0.4, 10), color: "#eceae2", position: [0, 0.2, 0] },
      { geometry: new THREE.CylinderGeometry(0.18, 0.3, 0.18, 10), color: "#f6f5ef", position: [0.02, 0.46, -0.02] },
      { geometry: new THREE.BoxGeometry(0.5, 0.1, 0.5), color: "#d2cfc4", position: [0, 0.05, 0] },
      { geometry: new THREE.ConeGeometry(0.1, 0.12, 6), color: "#7c8c4a", position: [-0.04, 0.58, 0.04] },
      { geometry: new THREE.IcosahedronGeometry(0.07, 0), color: "#f6f5ef", position: [0.34, 0.06, 0.1], rotation: [0.2, 0.5, 0.3] },
    ],
  animations: [],
});
